import React from "react";
import { useSelector } from "react-redux";
import { getAppraisalData } from "../../store/selectors";

export const ValuationVehicleDetails = ({
  showPromoBranding
}: {
  showPromoBranding: boolean;
}) => {
  const { vehicle } = useSelector(getAppraisalData);

  const { manufacturer, model, registration } = vehicle;

  const make = `${manufacturer} ${model}`;

  const content = (
    <div
      className={`ch-display--flex ch-flex-flow--row ch-align-items--center ch-justify-content--center`}
    >
      <div
        className="ch-chip ch-chip--yellow ch-chip--lg ch-mr--1 registration-chip-part-exchange"
        data-testid="vehicle-registration"
      >
        {registration}
      </div>
      <p className="ch-mb--0 ch-fs--2 lg:ch-fs--3" data-testid="vehicle-make">
        {make}
      </p>
    </div>
  );
  return (
    <>
      {showPromoBranding ? (
        <div className="ch-mv--3">
          <div className="ch-card promo-vehicle-details-card">
            <div className="ch-card__content ch-pa--4">{content}</div>
          </div>
        </div>
      ) : (
        <div className="ch-mb--3 ch-ph--2">{content}</div>
      )}
    </>
  );
};
